/* import __COLOCATED_TEMPLATE__ from './list.hbs'; */
/* RESPONSIBLE TEAM: team-conversational-knowledge */

import Component from '@glimmer/component';
import type AiContentLibraryApi from 'embercom/lib/ai-content-library/list-api';
import { restartableTask } from 'ember-concurrency-decorators';
import { type TaskGenerator } from 'ember-concurrency';
import { action } from '@ember/object';
import type { EditorMode } from 'embercom/components/knowledge-hub/content-editor/drawer-editor';
import type KnowledgeHubEditorService from 'embercom/services/knowledge-hub-editor-service';
import { inject as service } from '@ember/service';
import { taskFor } from 'ember-concurrency-ts';

interface Args {
  listApi: AiContentLibraryApi;
  activeContentId?: number;
  activeContentType?: string;
  showTopics?: boolean;
}

export default class List extends Component<Args> {
  @service declare knowledgeHubEditorService: KnowledgeHubEditorService;

  get totalCount() {
    return this.args.listApi.totalCount;
  }

  get isLoading() {
    return this.args.listApi.isLoadingPage && !this.isPaginating;
  }

  get isPaginating() {
    return taskFor(this.paginate).isRunning;
  }

  @action
  openSuggestionInEditor(contentId: number, contentObjectName: string, editorMode: EditorMode) {
    this.knowledgeHubEditorService.openActiveContent(contentId, contentObjectName, editorMode);
  }

  @restartableTask
  *paginate(): TaskGenerator<void> {
    if (!this.args.listApi.isLoadingPage) {
      yield this.args.listApi.loadPage();
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Suggestions::List': typeof List;
    'ai-agent/suggestions/list': typeof List;
  }
}
